const packageId = 'user-tracking'

export default [

  // Admin
  {
    path: `/admin/${packageId}`,
    name: `admin.${packageId}.index`,
    redirect: { name: `admin.${packageId}.dashboard` },
    component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/index`),
    children: [
      { path: 'dashboard', name: `admin.${packageId}.dashboard`, component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/dashboard`) },
      { path: 'configuration', name: `admin.${packageId}.configuration`, component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/configuration`) },
    ]
  },
  {
    path: `/admin/${packageId}/group/:id/`,
    name: `admin.${packageId}.group`,
    component: () => import(/* webpackChunkName: 'js/packages/[request]' */ `packages/${packageId}/resources/js/pages/admin/group/index`), props: true
  }
]